import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { IFileItem } from '../../../types/api/FileItem';
import ContentMessage from '../../../_lib/components/ContentMessage/ContentMessage';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { AttachedFilesBaseList } from '../../../_lib/components/AttachedFilesBase';

export type AttachedFilesDefaultViewProps = {
  attachments?: IFileItem[];
};
function AttachedFiles({ attachments = [] }: AttachedFilesDefaultViewProps) {
  const { t } = useSonTranslation('AttachedFiles');
  if (attachments.length === 0) {
    return <ContentMessage text={t('noAttachments')} />;
  }

  return <AttachedFilesBaseList attachments={attachments} />;
}

export const AttachedFilesDefaultView = asView(AttachedFiles);
export type AttachedFilesDefaultView = ComponentProps<typeof AttachedFilesDefaultView>;
